import React, { Component } from "react";
import { Table } from "antd";
import moment from "moment";
import { Parse } from 'nbugs-pc-import-parse';
import styles from "./index.less";

class Index extends Component {

  render() {
    const statusMap = { 3: "发布中", 4: "发布成功", 2: "待发布", 6: "已撤回", 1: "草稿", 5: '发布失败' };
    const statusClassMap = { 3: "yellow", 4: "green", 2: "blue", 6: "grey", 1: "yellow", 5: 'red' };
    const { data, from, onPageChange } = this.props;
    const { title, salaryMonth = '', sendStatus, senderName = '', sendTime = '', dataSource = [], columns = [], totalElements, page, nameImportId } = data || {};
    // 分页器属性
    const pagination = {
      showQuickJumper: true,
      showSizeChanger: true,
      defaultCurrent: page,
      current: page,
      defaultPageSize: 10,
      total: totalElements,
      onShowSizeChange: onPageChange,
      onChange: onPageChange,
      showTotal: () => `共 ${totalElements} 条记录`,
    };

    const parseProps = {
      taskId: nameImportId,
      editable: false,
    };
    return (
      <div className={styles.root}>
        <div className='first-part'>
          <div className="title">
            <div className='left' />
            <div className='right'>
              {title}
              {from == 'manage' && sendStatus && (
                <span className={`status ${statusClassMap[sendStatus]}`}>{statusMap[sendStatus]}</span>
              )}
            </div>
          </div>
          <div className='content-area'>
            <div className='send-item'>
              <span className='title-word'>发 布 者</span>:<span>{senderName}</span>
            </div>
            <div className='send-item'>
              <span className='title-word'>发放月份</span>:<span>{salaryMonth || '-'}</span>
            </div>
            <div className='send-item'>
              <span className='title-word'>发布时间</span>:<span>{sendTime && moment(sendTime).format("YYYY.MM.DD HH:mm")}</span>
            </div>
          </div>
        </div>
        <div className='second-part'>
          {
            sendStatus == 1 ? <Parse {...parseProps} /> : <Table scroll={{ x: 'max-content' }} dataSource={dataSource} columns={columns} pagination={from == 'manage' ? pagination : {}} />
          }
        </div>
      </div>
    );
  }
}

export default Index;
